export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
